import React, { useEffect, useState } from "react";

const Timer = ({
  min = 2,
  sec = 0,
  callback,
  checkStatus,
}) => {
  const [minutes, setMinutes] = useState(min);
  const [seconds, setSeconds] = useState(sec);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if(seconds % 5 === 0) {
        checkStatus();
      }
      if (seconds > 0) {
        setSeconds((seconds) => seconds - 1);
      } else {
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval);
            callback();
          } else {
            setMinutes((minutes) => minutes - 1);
            setSeconds(59);
          }
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [minutes, seconds]);

  return (
      <h1 className="timer-text">
        This QR code is valid for{" "}
        <span className="qr-code-timer">
          {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </span>{" "}
        minutes
      </h1>
  );
};

export default Timer;
